import React from 'react';
import { Translate } from 'react-redux-i18n';

import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  COLLAB_INFO_DRAWER,
  COLLABORATORS_MANAGEMENT,
  PROFESSIONAL_INFO_FORM,
  STRUCTURE_INFO_FORM,
} from '../../../../routes';
import chevronDroite from '../../../../img/icones/chevron_droite.svg';
import structure from '../../../../img/home/structure.svg';
import structureYellow from '../../../../img/home/structure_yellow.svg';
import structureRed from '../../../../img/home/structure_red.svg';
import comptesCollaborateurs from '../../../../img/icones/comptes_collaborateurs.svg';
import infosProfessionnelles from '../../../../img/icones/infos_professionnelles.svg';
import infosStructure from '../../../../img/icones/infos_structure.svg';
import infosCollaborateurs from '../../../../img/icones/infos_collaborateurs.svg';
import { Entity } from '../../../../network/api/types/compte/Entity';
import ConfirmationModal from '../../../common/modals/ConfirmationModal';
import { RattachementDemand } from '../../../../network/api/types/RattachementDemand';
import rattachementDemandApi from '../../../../network/api/rattachementDemandApi';
import { notifyErrorWithMessage } from '../../../common/Notification';
import { getStructureName } from '../../../../services/utils';
import compteApi from '../../../../network/api/compteApi';
import Button from '../../../common/Button';

type Props = RouteComponentProps & {
  entity?: Entity,
  openDrawer?: (route: string, isManager?: boolean) => void,
  structureName?: string,
  isManager?: boolean,
  rattachement?: RattachementDemand,
  reloadList?: () => void,
  isBlock?: boolean,
  updateNeeded?: number,
  updateCollaborateurStatut?: () => void,
  idn?: string,
  removeRattachement?: (idEntity: string) => void,
};

type State = {
  isOpen: boolean,
  collaborateurStatut?: number,
};

class Box {
  img: string;

  className: string;

  constructor(img, className) {
    this.img = img;
    this.className = className;
  }

  static VALID = new Box(structure, 'primary');

  static BLOCKED = new Box(structureRed, 'red');

  static PENDING = new Box(structureYellow, 'yellow');
}

class StructureBox extends React.Component<Props, State> {
  state: State = {
    isOpen: false,
  };

  static defaultProps = {
    isBlock: false,
  };

  openModal = () => this.setState((prevState: State) => ({ isOpen: !prevState.isOpen }));

  componentDidMount() {
    if (this.props.updateCollaborateurStatut) {
      this.props.updateCollaborateurStatut();
    }
  }

  deleteRattachementDemand = () => {
    rattachementDemandApi.delete(this.props.rattachement.id)
      .then(() => {
        this.openModal();
        this.props.reloadList();
      })
      .catch((err) => {
        if (typeof err.then === 'function') {
          notifyErrorWithMessage('Une erreur est survenue.');
          return null;
        }
        return null;
      });
  };

  deleteRattachement = () => {
    compteApi.leaveEntite(`${this.props.idn}_${this.props.entity.id}`)
      .then(() => {
        this.openModal();
        this.props.removeRattachement(this.props.entity.id);
      })
      .catch((err) => {
        if (typeof err.then === 'function') {
          notifyErrorWithMessage('Une erreur est survenue.');
          return null;
        }
        return null;
      });
  };

  getManagerMessage = () => {
    if (this.props.updateNeeded && this.props.updateNeeded !== 0) {
      return <span className="warning"><Translate value="HOME.UPDATE_COLLAB_STATUT" number={this.props.updateNeeded} /></span>;
    }
    return <Translate value="HOME.UPDATE_COLLAB_INFO" />;
  };

  render(): React.ReactElement {
    let boxType;
    if (this.props.structureName) {
      boxType = Box.PENDING;
    } else if (this.props.isBlock) {
      boxType = Box.BLOCKED;
    } else boxType = Box.VALID;
    return (
      <div className="account-box professional-box">
        <ConfirmationModal
          titleI18nKey={boxType === Box.VALID
            ? 'rattachement.DETACH'
            : 'rattachement.DELETE'}
          subtTitleI18nKey={boxType === Box.VALID
            ? 'rattachement.SUBTITLE_DETACH'
            : 'rattachement.SUBTITLE_DELETE'}
          confirmationButtonI18nKey="actions.DELETE"
          onConfirm={boxType === Box.VALID
            ? this.deleteRattachement
            : this.deleteRattachementDemand}
          isOpen={this.state.isOpen}
          onClose={this.openModal}
          confirmeDisabled={false}
          entite={boxType === Box.VALID
            ? this.props.entity.name
            : this.props.rattachement && this.props.rattachement.shortCompanyName}
        />
        <div className={`box-line structure-overview column ${boxType.className}`}>
          <div className="overviou">
            <div className="box-img">
              <div className="container-img">
                <img
                  src={boxType.img}
                  alt="emergency"
                />
              </div>
            </div>
            <div className="structure-info">
              <div className="box-line column no-border">
                <h4>
                  <div
                    className={`title-background ${boxType.className}`}
                  />
                  <span className={boxType.className}>
                    {getStructureName(this.props.entity)
                    || this.props.structureName}
                  </span>
                </h4>
                <div className="subtitle">
                  <span>
                    <Translate value={this.props.entity?.rattachement.linkType || 'collaborators.collaborator'} />
                  </span>
                </div>
                {this.props.structureName && (
                  <div className="subtitle yellow">
                    <Translate value="rattachement.pending" />
                  </div>
                )}
                {this.props.isBlock && (
                  <div className="subtitle red">
                    <Translate value="rattachement.blocked" />
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.props.entity?.rattachement.manager
          && !this.props.isBlock
          && (
            <div className="manager-instructions">
              <Translate value="PROFESSIONAL_INFORMATION.MANAGER" />
            </div>
          )}
        </div>
        {this.props.entity
        && !this.props.isBlock
        && (
          <div className="my-pro-info box-line">
            <button
              type="button"
              className="info-row"
              onClick={() => this.props.openDrawer(`${PROFESSIONAL_INFO_FORM}/${this.props.entity.id}`)}
            >
              <img
                className="home-smol-icon my-pro-info-icon"
                src={infosProfessionnelles}
                alt="my-pro-info-icon"
              />
              <div className="chevron-helper">
                <h5 className="button-title">
                  <Translate value="HOME.MY_PRO_INFO" />
                </h5>
                <div className="button-subtitle">
                  <Translate value="HOME.UPDATE_MY_PRO_INFO" />
                </div>
              </div>
              <img
                className="chevron"
                src={chevronDroite}
                alt="chevron"
              />
            </button>
          </div>
        )}
        {this.props.entity?.rattachement.manager
        && !this.props.isBlock
        && (
          <div className="collab-accounts box-line">
            <button
              type="button"
              className="info-row"
              onClick={() => this.props.history.push(COLLABORATORS_MANAGEMENT.replace(':entiteId', this.props.entity.id))}
            >
              <img
                className="home-smol-icon collab-accounts-icon"
                src={comptesCollaborateurs}
                alt="collab-accounts-icon"
              />
              <div className="chevron-helper">
                <h5 className="button-title">
                  <Translate value="HOME.COLLAB_ACCOUNTS" />
                </h5>
                <div className="button-subtitle">
                  <Translate value="HOME.MANAGE_COLLAB_ACCOUNTS" />
                </div>
              </div>
              <img
                className="chevron"
                src={chevronDroite}
                alt="chevron"
              />
            </button>
          </div>
        )}
        {this.props.entity
        && !this.props.isBlock
        && (
          <>
            <div className="collab-info box-line">
              <button
                type="button"
                className="info-row"
                onClick={() => this.props.openDrawer(`${COLLAB_INFO_DRAWER}/${this.props.entity.id}`, this.props.isManager)}
              >
                <img
                  className="home-smol-icon collab-info-icon"
                  src={infosCollaborateurs}
                  alt="collab-info-icon"
                />
                <div className="chevron-helper">
                  <h5 className="button-title">
                    <Translate value="HOME.COLLAB_INFO" />
                  </h5>
                  <div className="button-subtitle">
                    {this.props.isManager
                      ? this.getManagerMessage()
                      : <Translate value="HOME.CONSULT_COLLAB_INFO" />}
                  </div>
                </div>
                <img
                  className="chevron"
                  src={chevronDroite}
                  alt="chevron"
                />
              </button>
            </div>
            <div className="structure-info box-line no-border">
              <button
                type="button"
                className="info-row"
                onClick={() => this.props.openDrawer(`${STRUCTURE_INFO_FORM}/${this.props.entity.id}`, this.props.isManager)}
              >
                <img
                  className="home-smol-icon structure-info-icon"
                  src={infosStructure}
                  alt="structure-info-icon"
                />
                <div className="chevron-helper">
                  <h5 className="button-title">
                    <Translate value="HOME.STRUCTURE_INFO" />
                  </h5>
                  <div className="button-subtitle">
                    {this.props.isManager
                      ? <Translate value="HOME.UPDATE_STRUCTURE_INFO" />
                      : <Translate value="HOME.CONSULT_STRUCTURE_INFO" />}
                  </div>
                </div>
                <img
                  className="chevron"
                  src={chevronDroite}
                  alt="chevron"
                />
              </button>
            </div>
          </>
        )}
        { this.props.entity
          && this.props.entity.rattachement.linkType === 'Collaborateur'
          && (
            <div className="action-button box-line no-border top-line">
              <Button
                type="secondary"
                onClick={() => this.openModal()}
              >
                <Translate value="actions.DETACH" />
              </Button>
            </div>
          )}
        {this.props.structureName && (
          <>
            <div className="action-button box-line no-border top-line">
              <Button
                type="secondary"
                className="yellow"
                onClick={() => this.openModal()}
              >
                <Translate value="rattachement.DELETE_DEMAND" />
              </Button>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default withRouter(StructureBox);
